export default () => `go get github.com/Flagsmith/flagsmith-go-client/v5

import (
  "github.com/Flagsmith/flagsmith-go-client/v5"
)
`
